"use client";

import { c as _c } from "react/compiler-runtime";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
import { SITE_TYPE_FOOTBALL_COMPETITION, SITE_TYPE_BASIC } from "@/config/siteTypes";
import { EntityResultCard } from "./EntityResultCard";
import type { SearchEntity } from "./useSearchPage";
interface EntitySectionProps {
  title: string;
  items: SearchEntity[];
  kind: "teams" | "players" | "competitions";
}
export function EntitySection(t0) {
  const $ = _c(16);
  const {
    title,
    items,
    kind
  } = t0;
  const nav = useNavigation();
  const {
    siteType
  } = useTenantSettings();
  const isCompetitionSite = siteType === SITE_TYPE_FOOTBALL_COMPETITION;
  if (siteType === SITE_TYPE_BASIC) {
    return null;
  }
  if (items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== isCompetitionSite || $[1] !== kind || $[2] !== nav) {
    t1 = entity => {
      switch (kind) {
        case "teams":
          {
            return nav.team(entity.entityId);
          }
        case "players":
          {
            return nav.player(entity.entityId);
          }
        case "competitions":
          {
            if (isCompetitionSite) {
              return null;
            }
            try {
              return nav.footballCompetition(entity.entityId);
            } catch {
              return null;
            }
          }
      }
    };
    $[0] = isCompetitionSite;
    $[1] = kind;
    $[2] = nav;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const buildHref = t1;
  let t2;
  if ($[4] !== title) {
    t2 = <h2 className="text-xs uppercase tracking-wider text-muted-foreground font-semibold mb-3">{title}</h2>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== buildHref || $[7] !== items) {
    let t4;
    if ($[9] !== buildHref) {
      t4 = entity_0 => <EntityResultCard key={entity_0.entityId} entity={entity_0} href={buildHref(entity_0)} />;
      $[9] = buildHref;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = items.map(t4);
    $[6] = buildHref;
    $[7] = items;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">{t3}</div>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = <section className="mt-8">{t2}{t4}</section>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}